import avatar from 'flarum/common/helpers/avatar';
import Dropdown from 'flarum/common/components/Dropdown';
import highlight from 'flarum/common/helpers/highlight';
import Stream from 'flarum/common/utils/Stream';
import loadAgentsList from '../../utils/loadAgentsList';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

export default class TicketAssigneeFilter extends Dropdown {
  static initAttrs(attrs) {
    attrs.icon = 'fas fa-user';
    attrs.label = 'Assignees';

    attrs.buttonClassName = 'Button';
    attrs.menuClassName = 'Dropdown-menu--right Dropdown--assignees';
    attrs.accessibleToggleLabel = 'Assignees';

    super.initAttrs(attrs);
  }

  oninit(vnode) {
    this.search = Stream('');
    this.searchInput = null;

    this.loaded = false;
    this.userList = [];

    loadAgentsList((list) => {
      this.userList = list;
      this.loaded = true;
    });

    super.oninit(vnode);
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    this.$().on('shown.bs.dropdown', () => {
      this.searchInput.focus();
    });
  }

  getMenu() {
    const assignees = this.attrs.assignees;

    const filteredList = this.userList.filter((user) => {
      if (this.search() === '') return true;

      return user.displayName().toLocaleLowerCase().indexOf(this.search().toLocaleLowerCase()) >= 0;
    });

    const search = this.search();
    const isSearching = search !== '';
    const expression = isSearching ? new RegExp(search + '|' + search.trim().replace(/\s+/g, '|'), 'gi') : null;

    return (
      <ul
        className={'Dropdown-menu dropdown-menu ' + this.attrs.menuClassName}
        onclick={(e) => {
          e.stopPropagation();
        }}
      >
        <li>
          <div class="Dropdown-header">{app.translator.trans('v17development-flarum-support.forum.tickets.overview.filter.assignees.title')}</div>
          <div className={'DropdownSearch'}>
            <input
              type={'text'}
              className={'FormControl'}
              placeholder={app.translator.trans('v17development-flarum-support.forum.tickets.overview.filter.assignees.search')}
              bidi={this.search}
              oncreate={(e) => (this.searchInput = e.dom)}
              onkeyup={(e) => {
                // Select first result
                if (e.keyCode === 13 && isSearching) {
                  if (filteredList.length >= 1) {
                    this.attrs.filterAssignee(filteredList[0].id());
                  } else {
                    this.attrs.filterAssignee('unassigned');
                  }
                }
                // Reset search
                else if (e.keyCode === 27 && isSearching) {
                  this.search('');
                }
              }}
            />
          </div>
        </li>

        {filteredList.map((user, key) => {
          return (
            <li className={isSearching && key === 0 ? 'FilteredListSearchFirst' : null}>
              <Button
                className={'Button'}
                icon={assignees.indexOf(user.id()) >= 0 ? 'fa fa-check' : 'fa'}
                onclick={() => this.attrs.filterAssignee(user.id())}
              >
                {avatar(user)}

                {highlight(user.displayName(), expression)}
              </Button>
            </li>
          );
        })}

        <li className={isSearching && filteredList.length === 0 ? 'FilteredListSearchFirst' : null}>
          <Button
            className={'Button'}
            icon={assignees.indexOf('unassigned') >= 0 ? 'fa fa-check' : 'fa'}
            onclick={() => this.attrs.filterAssignee('unassigned')}
          >
            {highlight(app.translator.trans('v17development-flarum-support.forum.tickets.overview.filter.assignees.unassigned'), expression)}
          </Button>
        </li>

        {filteredList.length === 0 && (
          <li className={'DropdownSearchNoResults'}>
            {app.translator.trans('v17development-flarum-support.forum.search.no_results', {
              searchterm: <b>{this.search()}</b>,
            })}
          </li>
        )}
      </ul>
    );
  }
}
